import styled from 'styled-components'

export const AcceptButtonContainer = styled.div`
display: flex;
justify-content: center;
`
